import _extends from "@babel/runtime/helpers/esm/extends";
import Toast from '../toast';
import { route, routeProps } from '../utils/router';
import { createNamespace } from '../utils';
import Checkbox from '../checkbox';
import Button from '../button';

var _createNamespace = createNamespace('approve-agreement'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  model: {
    prop: 'checked',
    event: 'update'
  },
  props: _extends({}, routeProps, {
    checked: Boolean,
    textRegex: {
      type: RegExp,
      default: function _default() {
        return /(.+)(《.+》)/;
      }
    },
    text: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: '请认真阅读并确认勾选协议'
    },
    shape: {
      type: String,
      default: 'round'
    },
    iconSize: [Number, String],
    checkedColor: String,
    buttonText: String
  }),
  data: function data() {
    return {};
  },
  computed: {
    linkText: function linkText() {
      var text = this.text,
          textRegex = this.textRegex;

      if (text && textRegex) {
        var match = text.match(textRegex);
        return match && match[1] && match[2] ? {
          pre_text: match[1],
          link_text: match[2]
        } : {
          pre_text: text,
          link_text: ''
        };
      }

      return {
        pre_text: '',
        link_text: ''
      };
    },
    agree: {
      get: function get() {
        return this.checked;
      },
      set: function set(val) {
        this.$emit('update', val);
      }
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
      route(this.$router, this);
    },
    onChange: function onChange(e) {
      this.$emit('change', e);
    },
    onClickButton: function onClickButton() {
      if (!this.agree) {
        Toast(this.message);
        return;
      }

      this.$emit('success');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("div", {
      "class": bem('')
    }, [h(Checkbox, {
      "class": bem('checkbox'),
      "attrs": {
        "shape": this.shape,
        "iconSize": this.iconSize,
        "checkedColor": this.checkedColor
      },
      "on": {
        "change": this.onChange
      },
      "model": {
        value: _this.agree,
        callback: function callback($$v) {
          _this.agree = $$v;
        }
      }
    }), h("div", {
      "class": bem('text')
    }, [this.linkText.pre_text, h("span", {
      "on": {
        "click": this.onClick
      },
      "class": this.linkText.link_text ? bem('link') : ''
    }, [this.linkText.link_text])]), this.slots('right') || (this.buttonText ? h(Button, {
      "attrs": {
        "type": "primary"
      },
      "class": this.agree ? bem('button') : bem('disabled') + " " + bem('button'),
      "on": {
        "click": this.onClickButton
      }
    }, [this.buttonText]) : null)]);
  }
});